var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { WaveButtonStyled, WaveDarkStyled, WaveLightStyled } from './styled';
import Icon from '../Icon';
const WaveButton = (_a) => {
    var { onClick } = _a, props = __rest(_a, ["onClick"]);
    const { endAnimation, middleAnimation, startIcon, endIcon, disabled } = props;
    const [active, setActive] = useState(false);
    const handleClick = (event) => {
        onClick(event);
        setActive(true);
    };
    useEffect(() => {
        if (!endAnimation) {
            setActive(false);
        }
    }, [endAnimation]);
    useEffect(() => {
        setActive(middleAnimation);
    }, [middleAnimation]);
    return (_jsxs(WaveButtonStyled, Object.assign({}, props, { disabled: (!endAnimation && active) || disabled, middleAnimation: middleAnimation || active, onClick: handleClick }, { children: [_jsx(Icon, { style: { position: 'absolute', zIndex: 2 }, styleIcon: { transition: 'background 2s' }, name: startIcon || 'lockOutlined', size: "30px", color: endAnimation || active ? 'transparent' : '#0057B8' }), _jsx(Icon, { style: { position: 'absolute', zIndex: 2 }, styleIcon: { transition: 'background 2s' }, name: endIcon || 'lockOpenOutlined', size: "30px", color: endAnimation || active ? '#FFF' : 'transparent' }), _jsx(WaveDarkStyled, { className: "wave-dark" }), _jsx(WaveLightStyled, { className: "wave-light" })] })));
};
WaveButton.defaultProps = {
    middleAnimation: false,
};
export default WaveButton;
//# sourceMappingURL=index.js.map